// src/components/Dashboard/MainGrid.js
import React from 'react';
import Grid from '@mui/material/Grid';

const MainGrid = ({ children, spacing = 3 }) => {
  return (
    <Grid container spacing={spacing} sx={{ padding: 2, borderRadius: 2 }}>
      {children}
    </Grid>
  );
};

export default MainGrid;
